import React from 'react';
import { Panel, ListGroup, ListGroupItem, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';

import { statusTypes, pointCategories } from "../config/constants";

const PointsSummary = (props) => {
  const { points } = props;

  const outputPointCategories = pointCategories.map((category) => {
    const { id, text: categoryText, type } = category;
    // Points object is created empty when the application is created.
    // If you jump straight to the summary, page breaks so we set defaults
    const pointsCategory = points[id] ? points[id] : {points: 0, text: 'Not Calculated', status: false};
    const { points: pointValue, text, status } = pointsCategory;
    const value = (type === 'points' || type === 'section' || type === 'total') ?
      pointValue
      :
      (
        (type === 'status') ?
          (status ? 'Requirement Met' : 'Requirement Not Met')
          :
          'Unknown Category Type'
      );
    const title = (type === 'points' || type === 'status') ?
      'Criterion ' + id
      :
      (
        (type === 'section') ?
          'Section ' + id
          :
          (type === 'total') ?
            'Total'
            :
            'Unknown'
      );
    return (
      <ListGroupItem key={id}>
        <Row><Col sm={2}>{title}</Col><Col sm={4}>{categoryText}</Col><Col sm={2}>{value}</Col><Col sm={4}>{text}</Col></Row>
      </ListGroupItem>
    );
  });

  return(
    <Panel className="points-info-panel" header={props.header ? props.header : 'Points Summary'} bsStyle={statusTypes.INFO}>
      <ListGroup>
        {points ? outputPointCategories : (<div>Points not yet calculated</div>)}
      </ListGroup>
      <p>Note: Points listed is an estimation only and may changed based on evaluation and documentation.</p>
    </Panel>
  );
};

function mapStateToProps(state) {
  const { application } = state.appInfo;
  const { points } = application;
  return {
    points
  }
}

export default connect(mapStateToProps)(PointsSummary);